import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import UnfoldingCanvas from './UnfoldingCanvas';

const EMPTY_INPUT_NODES = [];
const EMPTY_NODE_STATE = {};

const DRAFT_MAIN_FLOW = {
  id: 0,
  name: 'Main Flow',
  orderIndex: 0,
  is_main: 1,
  trigger_mode: 'event',
  auto_run_enabled: false,
};

const ProjectDagDraftView = ({ onStart }) => {
  const { t, i18n } = useTranslation();
  const flow = useMemo(() => ({
    ...DRAFT_MAIN_FLOW,
    name: t('dag.main_flow', 'Main Flow'),
  }), [t]);
  const flowBranches = useMemo(() => [{
    flow,
    nodes: [{
      key: `flow:${flow.id}`,
      id: flow.id,
      item: flow,
      label: flow.name,
      kind: 'output',
      nodeType: 'flow',
      flowState: 'empty',
      actionCount: 0,
      outputLoading: false,
      flowSummary: t('workflow.flow_summary_empty', 'No actions are configured in this flow yet.'),
    }],
  }], [flow, t]);
  const actionControls = useMemo(() => ({
    canManage: true,
    workflowFlows: [flow],
    onAddAfter: () => onStart('action'),
    onAddConnector: () => onStart('connector'),
    onAddFlow: () => onStart('flow'),
  }), [flow, onStart]);

  return (
    <UnfoldingCanvas
      caseid={null}
      inputNodes={EMPTY_INPUT_NODES}
      flowBranches={flowBranches}
      nodeErrors={EMPTY_NODE_STATE}
      nodeRuntime={EMPTY_NODE_STATE}
      loading={false}
      inputLoading={false}
      outputLoading={false}
      outputError={false}
      isEditorOpen={false}
      onNodeActivate={(node) => {
        if (node?.nodeType === 'flow') onStart('flow');
      }}
      actionControls={actionControls}
      canManageProject
      showDraftTutorial
      locale={i18n?.resolvedLanguage || i18n?.language}
      t={t}
    />
  );
};

export default React.memo(ProjectDagDraftView);
